import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductBundle, ProductBundleCreate, ProductBundleFilter } from '../data/productBundle';

export function createProductBundleService(client: AxiosInstance) {
  return createCrudService<ProductBundle, ProductBundleCreate, ProductBundleFilter>(
    client,
    '/master-data/ProductBundle',
    'id',
  );
}

export type ProductBundleService = CrudService<ProductBundle, ProductBundleCreate, ProductBundleFilter>;
